import { ErrorHandler, importProvidersFrom, inject, provideAppInitializer, provideZoneChangeDetection } from "@angular/core";
import { registerLocaleData } from "@angular/common";
import { bootstrapApplication } from '@angular/platform-browser';
import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules, Router } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { IonicStorageModule, Storage } from '@ionic/storage-angular';
import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { GlobalErrorHandler } from "./app/core/handlers/global-error.handler";
import { authInterceptor } from "./app/core/interceptors/auth.interceptor";
import localeEs from '@angular/common/locales/es';
import packageJson from '@packageJson';
import * as Sentry from '@sentry/angular';

registerLocaleData(localeEs, 'es');

if (environment.production) {

  Sentry.init({
    dsn: 'https://c72f8b6c8ddca90dcc343998c126b94d@sentry.yurest.dev/20',
    environment: 'production',
    release: `yurest_fichador@${packageJson.version}`,
    dist: packageJson.version,
    integrations: [Sentry.browserTracingIntegration({enableInp: true})],
    tracesSampleRate: 0.1,
  });

}

bootstrapApplication(AppComponent, {
  providers: [
    {provide: ErrorHandler, useClass: GlobalErrorHandler},
    {provide: Sentry.TraceService, deps: [Router]},
    importProvidersFrom(IonicModule.forRoot({
      mode: 'ios',
      backButtonText: '',
      backButtonDefaultHref: '',
      useSetInputAPI: true,
    })),
    importProvidersFrom(IonicStorageModule.forRoot()),
    provideZoneChangeDetection({eventCoalescing: true}), { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideAppInitializer(async () => {
      inject(Sentry.TraceService);
      const storage: Storage = inject(Storage);

      await storage.create();
    }),
  ],
});